<script>
    import {Html5Qrcode} from "html5-qrcode"
    import { Button, Icon, Dialog, TextField } from 'svelte-materialify';
    import { mdiCamera, mdiArrowLeft } from '@mdi/js';
    import { email, mode, provetta } from '../store';
    
    export let window;
    export let isVisible;
    export let value;
    export let server;

    $: isVisible, askCode();
    
    let _email, _mode, _provetta, codeOtp = "";
    let seconds = 0;
    let token = null;

    email.subscribe(val => _email = val);
    mode.subscribe(val => _mode = val);
    provetta.subscribe(val => _provetta = val);

    const rules = [
        v => v.length >= 4 || "Troppo corto"
    ];

    function askCode() {

        if(!isVisible)
            return;

        codeOtp = "";

        let params = new FormData();
        if(_mode === "start")
            params.append("email", _email);
        else
            params.append("id_provetta", _provetta);

        let url = _mode === "start" ? `https://${server}.sensesquare.eu:5002/otp_provetta` : `https://${server}.sensesquare.eu:5002/otp_chiusura`;

        fetch(url, {
            method: "POST",
            body: params,
        })
        .then(response => response.json())
        .then(result => {
            token = result.result;
            if(result.response_code === 200)
                updateTime();
            else
                alert("Ops! Sembra esserci un problema, riprova più tardi");
        })
        .catch(e => {
            alert("Ops! Sembra esserci un problema, riprova più tardi");
            console.log(e);
        });

    }

    function checkCode(code) {

        let params = new FormData();
        params.append("token", token);
        params.append("otp", codeOtp);
        fetch(`https://${server}.sensesquare.eu:5002/verifica_mail_provette`, {
            method: "POST",
            body: params,
        })
        .then(response => response.json())
        .then(result => {
            if(result.response_code === 200)
                window.next();
            else
                alert(result.message);
        })
        .catch(e => {
            alert("Ops! Sembra esserci un problema, riprova più tardi");
            console.log(e);
        });

    }

    async function updateTime() {
        seconds = 300;
        while(seconds > 0) {
            await wait();
            seconds -= 1;
        }
    }

    function wait(mill=1000) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, mill);
        });
    }

    function getETA(s) {
        let minutes = Math.floor((s / 60));
        let seconds = (s % 60).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        return `${minutes}:${seconds}`;
    }

</script>

<main>    
        
    <div class="pa-3 permission-box white rounded-lg elevation-1">

        {#if seconds > 0}
        
            <TextField inputmode={"numeric"} {rules} bind:value={codeOtp} filled color="green">
                Codice OTP
            </TextField>

            <div class="text-caption black-text mb-3">
                Tempo rimanente {getETA(seconds)}
            </div>

        {/if}

        <Button text block class="green-text" on:click={askCode}>
            Chiedi nuovo codice OTP
        </Button>

        <Button disabled={!codeOtp} class="green" depressed block on:click={() => checkCode(codeOtp)}>
            Conferma
        </Button>

    </div>

    <div class="action-container pa-3">

        <Button rounded depressed class="green" on:click={() => {
            if(_mode === "start")
                window.previous();
            else
                value = 4;
        }}>
            <Icon path={mdiArrowLeft} class="mr-2" />
            Torna indietro
        </Button>
        
    </div>

</main>

<style>

    main {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: grid;
        place-items: center;
        overflow: hidden;
    }

    main > .permission-box {
        display: grid;
        place-items: center;
        max-width: 400px;
    }

    main > .permission-box > .description {
        text-align: justify;
    }

    main .camera-icon {
        display: grid;
        place-items: center;
    }

    #camera-viewer {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: grid;
        place-items: center;
    }

    #camera-viewer[isVisible=false] {
        visibility: hidden;
        pointer-events: none;
    }

    #frames {
        height: auto;
        width: 100%;
    }

    main > .action-container {
        position: absolute;
        width: 100%;
        height: auto;
        left: 0;
        bottom: 0;
        display: grid;
        place-items: center;
    }

</style>